import React from 'react';
import './PartnersSection.css';

// 파트너사 이미지들 import
import clabiPartnerImg from '../partner/clabi_partner_img.jpg';
import naverCloudPartnerImg from '../partner/naverCloud_partner_img.jpg';
import dbIncPartnerImg from '../partner/dbInc_partner_img.jpg';
import dsPartnerImg from '../partner/ds_partner_img.png';
import smPartnerImg from '../partner/sm_partner_img.jpg';
import exemPartnerImg from '../partner/exem_partner_img.jpg';
import eGPartnerImg from '../partner/eG_partner_img.jpg';
import redHatPartnerImg from '../partner/redHat_partner_img.jpg';
import lgCNSPartnerImg from '../partner/lgCNS_partner_img.jpg';
import jenniferPartnerImg from '../partner/jennifer_partner_img.png';
import cauchoPartnerImg from '../partner/caucho_partner_img.png';

function PartnersSection() {
  const partners = [
    { name: 'Clabi', image: clabiPartnerImg },
    { name: 'Naver Cloud', image: naverCloudPartnerImg },
    { name: 'DB Inc', image: dbIncPartnerImg },
    { name: 'DS', image: dsPartnerImg },
    { name: 'SM', image: smPartnerImg },
    { name: 'Exem', image: exemPartnerImg },
    { name: 'eG', image: eGPartnerImg },
    { name: 'Red Hat', image: redHatPartnerImg },
    { name: 'LG CNS', image: lgCNSPartnerImg },
    { name: 'Jennifer', image: jenniferPartnerImg },
    { name: 'Caucho', image: cauchoPartnerImg },
  ];

  return (
    <section className="partners-section">
      <div className="partners-container">
        <h2>파트너사</h2>
        <div className="partners-scroll">
          <div className="partners-track">
            {/* 첫 번째 세트 */}
            {partners.map((partner, index) => (
              <div key={`first-${index}`} className="partner-item">
                <img src={partner.image} alt={partner.name} />
              </div>
            ))}
            {/* 두 번째 세트 (무한 스크롤을 위해 복제) */}
            {partners.map((partner, index) => (
              <div key={`second-${index}`} className="partner-item">
                <img src={partner.image} alt={partner.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PartnersSection; 